module.exports = __webpack_public_path__ + "static/media/copy.1d5abd2f.svg";